<div class="app-wrapper" [ngClass]="{'maintenance': isMaintenance}">
    <app-header *ngIf="!isMaintenance"></app-header>
    <router-outlet [ngClass]="{'position-absolute': isMaintenance}"></router-outlet>
    <app-footer [isMaintenance]="isMaintenance"></app-footer>
    <session-timeout [ngClass]="{'position-absolute': isMaintenance}"></session-timeout>
    <cookie-policy *ngIf="showCookiePolicy" (cookieAgreed)="showCookiePolicy = false"></cookie-policy>
</div>